
import Vue from 'vue';
import { VueConstructor } from 'vue/types/vue';

export default (Vue as VueConstructor<Vue>).extend({
  methods: {
  handleLoginEvent() {
    const nextPath = '/modelpipeline';
    if (nextPath !== this.$route.path) {
      this.$router.push({ path: nextPath.toString() });
    }
  },
  },
  created() {
    this.$auth.addListener('loginEvent', this.handleLoginEvent);
  },
});
